import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsbEnum } from "@/utils/indicatorsEsb";
import { ResumeIndicatorB3Data } from "@/services/esus/indicator/esb/b3/getResumeIndicatorB3";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsbB3ResumeProps = {
	resume: ResumeIndicatorB3Data;
};

export function IndicatorEsbB3Resume({ resume }: Readonly<IndicatorEsbB3ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalToothExtractionProcedures,
		resume.totalProcedures
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Total de procedimentos"
					value={resume.totalProcedures.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de procedimentos"
							message="Quantidade de procedimentos preventivos, curativos e exodontias realizados no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Total de exodontias"
					value={resume.totalToothExtractionProcedures.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de exodontias"
							message="Quantidade de procedimentos de exodontia realizados no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Proced. preventivos/curativos"
					value={(
						resume.totalProcedures - resume.totalToothExtractionProcedures
					).toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Procedimentos preventivos/curativos"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de procedimentos preventivos ou curativos realizados no{" "}
								<br />
								período.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Classificação"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsbEnum.B3,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="Classificação"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de exodontias em relação aos procedimentos preventivos,
								curativos <br />e exodontias no período.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
		</Row>
	);
}
